// extracted by mini-css-extract-plugin
module.exports = {"avatar":"s-module--avatar--3Y-Mg","avatarLink":"s-module--avatarLink--1rbAq"};